import Widget from 'views/logic/widgets/Widget';
import type { WidgetState } from 'views/logic/widgets/Widget';

export const _deserializeWidgetConfig = <T>(widget: T) =>
  Widget
    // TODO: This needs to be fixed. Instead we should construct a type-specific widget config.
    .fromJSON(widget as unknown as WidgetState).config;

export default _deserializeWidgetConfig;
